const OPTIONS = [
  {
    value: "strong",
    label: "Strong",
    desc: "You're in regular contact",
  },
  {
    value: "moderate",
    label: "Moderate",
    desc: "You stay in touch occasionally",
  },
  {
    value: "weak",
    label: "Weak",
    desc: "You've met but rarely speak",
  },
];

export default function StrengthPicker({ value, onChange, disabled = false }) {
  return (
    <div className="strength-picker">
      {OPTIONS.map((opt) => (
        <button
          key={opt.value}
          type="button"
          className={`strength-option ${value === opt.value ? "selected" : ""}`}
          onClick={() => onChange(opt.value)}
          aria-pressed={value === opt.value}
          disabled={disabled}
        >
          <div className="strength-option-label">{opt.label}</div>
          <div className="strength-option-desc">{opt.desc}</div>
        </button>
      ))}
    </div>
  );
}
